import { useGraphStore } from "./test-graph/store";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLingueStore } from "../sistema/storeLingua";

import {
  apiPostAvpNodoAvatar,
  apiGetAvpNodoAvatar,
  apiGetAvpNodoTipoAvatar,
  apiGetAvpNodoAgent,
  apiGetAvpNodoLoadingImage,
  apiGetConFile,
  apiPostAvpNodoAdd,
  apiDeleteNodeAgent,
  apiDeleteNodeLoadingImage,
} from "../shared/manager/api_manager";
import AvpNodeContentArcsSection from "../avp/AvpNodeContentArcsSection";
import AvpNodeContentPlaylistSection from "../avp/AvpNodeContentPlaylistSection";
export default function GraphEditComponent({
  tipiAvvio,
  lingue,
  currentLingua,
  nodeActionCallback,
}) {
  const navigate = useNavigate();

  const { selectedNode, setSelectedNode, avp, aggiornaAvp, setAlertMessage } =
    useGraphStore((state) => state);
  const { selectedLinguaTesto } = useLingueStore((state) => state);

  const [updatedNode, setUpdatedNode] = useState(selectedNode);
  const [currentNodeArchi, setCurrentNodeArchi] = useState([]);
  const [tipoAvatarList, setTipoAvatarList] = useState([]);
  const [selectedSkipToNode, setSelectedSkipToNode] = useState(false);
  const [currentNodeAvatar, setCurrentNodeAvatar] = useState(null);
  const [currentNodeAgent, setCurrentNodeAgent] = useState(null);
  const [currentNodeLoadingImage, setCurrentNodeLoadingImage] = useState(null);
  const [currentNodeAvatarFile, setCurrentNodeAvatarFile] = useState(null);
  const [currentNodeLoadingFile, setCurrentNodeLoadingImageFile] =
    useState(null);

  const [errorApiEsterna, setErrorApiEsterna] = useState(false);
  useEffect(() => {
    setUpdatedNode(selectedNode);
    if (selectedNode.skipToNextNode) setSelectedSkipToNode(true);
    else setSelectedSkipToNode(false);
  }, [selectedNode]);

  useEffect(() => {
    setCurrentNodeArchi(selectedNode.archi);
    initPage();
  }, [selectedNode, currentLingua]);

  function onChangeValueCheckbox(event, field) {
    setUpdatedNode({ ...updatedNode, [field]: event.target.checked });
  }

  function onChangeValue(event, field) {
    if (field == "apiEsterna") {
      if (
        updatedNode.tipoAvvio == 4 &&
        (updatedNode.apiEsterna == null ||
          updatedNode.apiEsterna == undefined ||
          updatedNode.apiEsterna.length <= 5)
      ) {
        setErrorApiEsterna(true);
      } else {
        setErrorApiEsterna(false);
      }
    }

    if (field == "tipoAvvio") {
      ;
      let value = event.target.value;
      if (
        value == "4" &&
        (updatedNode.apiEsterna == null ||
          updatedNode.apiEsterna == undefined ||
          updatedNode.apiEsterna.length <= 5)
      ) {
        setErrorApiEsterna(true);
      } else {
        setErrorApiEsterna(false);
      }
    }

    if (field == "skipToNextNode" && event.target.value == "") {
      setUpdatedNode({ ...updatedNode, [field]: null });
    } else {
      setUpdatedNode({ ...updatedNode, [field]: event.target.value });
    }
  }
  function onChangeSetSelectedSkipToNode(event) {
    const val = event.target.checked;
    setSelectedSkipToNode(val);
    if (!val) {
      setUpdatedNode({ ...updatedNode, skipToNextNode: null });
    }
  }
  function onChangeValueNumber(event, field) {
    setUpdatedNode({ ...updatedNode, [field]: Number(event.target.value) });
  }
  function handleChnageLanguage(idLingua) {
    console.log("handleChnageLanguage", idLingua);
    nodeActionCallback("changeLang", idLingua);
  }
  function handleSelectFile() {
    //open file picker
    let tipoFile = 4;
    if (
      currentNodeAvatar != null &&
      currentNodeAvatar.tipoAvatar != null &&
      currentNodeAvatar.tipoAvatar !== ""
    ) {
      if (currentNodeAvatar.tipoAvatar == 1) {
        tipoFile = 5;
      } else if (currentNodeAvatar.tipoAvatar == 2) {
        // tipoFile = 4;
        navigate("/contenuti/agent/list?action=addtonode");
        return;
      }
      navigate(
        "/contenuti/pick?action=addtonode&tipocontenuto=" +
          tipoFile +
          "&node=" +
          selectedNode.idNodo +
          "&avp=" +
          avp.idAvp +
          "&lingua=" +
          currentLingua.idLingua
      );
    }
  }
  function handleSelectAvatar() {
    let tipoFile = 5;

    navigate(
      "/contenuti/pick?action=addtonode&tipocontenuto=" +
        tipoFile +
        "&node=" +
        selectedNode.idNodo +
        "&avp=" +
        avp.idAvp +
        "&lingua=" +
        currentLingua.idLingua
    );
  }
  function handleSelectAgent() {
    navigate("/contenuti/agent/list?action=addtonode");
  }

  function onDeleteAgent() {
    apiDeleteNodeAgent(
      selectedNode.idNodo,
      currentLingua.idLingua,
      function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          // if (pActionCallback!=null) {
          //   pActionCallback("arcDelete", selectedNode.idNodo, idArcoToDelete);
          // }
          // else {
          //   console.warn("pActionCallback is null", pActionCallback);
          // }
          aggiornaAvp(avp.idAvp);

          // setSelectedNode(String(selectedNode.idNodo));
        }
      }
    );
  }
  function handleOnSelectLoadingFile() {
    navigate(
      "/contenuti/pick?action=addloadingtonode&tipocontenuto=2" +
        "&node=" +
        selectedNode.idNodo +
        "&avp=" +
        avp.idAvp +
        "&lingua=" +
        currentLingua.idLingua
    );
  }

  function handleDeleteLoadingImage() {
    apiDeleteNodeLoadingImage(selectedNode.idNodo,currentLingua.idLingua, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        // if (pActionCallback!=null) {
        //   pActionCallback("arcDelete", selectedNode.idNodo, idArcoToDelete);
        // }
        // else {
        //   console.warn("pActionCallback is null", pActionCallback);
        // }
        aggiornaAvp(avp.idAvp);

        // setSelectedNode(String(selectedNode.idNodo));
      }
    });
  }

  function onTipoAvatarChange(event) {
    let tipoAvatar = eval(event.target.value);
    let tempNodeAvatar = null;
    if (currentNodeAvatar == null) {
      tempNodeAvatar = {};
    } else {
      tempNodeAvatar = currentNodeAvatar;
    }
    tempNodeAvatar.tipoAvatar = tipoAvatar;
    let newObj = Object.assign({}, tempNodeAvatar);
    setCurrentNodeAvatar(newObj);
  }
  function initPage() {
    apiGetAvpNodoTipoAvatar(function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setTipoAvatarList(response.data);

        //load current avatar
        apiGetAvpNodoAvatar(
          selectedNode.idNodo,
          currentLingua.idLingua,
          function (avatarResponse) {
            if (
              avatarResponse != null &&
              avatarResponse.status >= 200 &&
              avatarResponse.status < 400
            ) {
              console.log("currentAvatar", avatarResponse.data);
              if (
                avatarResponse.data != null &&
                avatarResponse.data.idFile != null &&
                avatarResponse.data.idFile != 0
              ) {
                apiGetConFile(
                  avatarResponse.data.idFile,
                  function (fileResponse) {
                    if (
                      fileResponse != null &&
                      fileResponse.status >= 200 &&
                      fileResponse.status < 400
                    ) {
                      setCurrentNodeAvatarFile(fileResponse.data);
                    }
                    setCurrentNodeAvatar(avatarResponse.data);
                  }
                );
              } else {
                setCurrentNodeAvatar(avatarResponse.data);
                setCurrentNodeAvatarFile(null);
              }
            } else {
              console.log("currentAvatar", null);
              setCurrentNodeAvatar(null);
              setCurrentNodeAvatarFile(null);
            }
          }
        );
        apiGetAvpNodoAgent(
          selectedNode.idNodo,
          currentLingua.idLingua,
          function (response) {
            if (
              response != null &&
              response.status >= 200 &&
              response.status < 400
            ) {
              setCurrentNodeAgent({
                ...currentNodeAgent,
                descFile: response.data.descrizione,
                tipoAvatar: 2,
              });
            } else {
              setTipoAvatarList(null);
              setCurrentNodeAgent(null);
            }
          }
        );
      }
    });

    //load current avatar
    apiGetAvpNodoLoadingImage(
      selectedNode.idNodo,
      currentLingua.idLingua,
      function (imageResponse) {
        if (
          imageResponse != null &&
          imageResponse.status >= 200 &&
          imageResponse.status < 400
        ) {
          console.log("currentAvatar", imageResponse.data);
          if (
            imageResponse.data != null &&
            imageResponse.data.idFile != null &&
            imageResponse.data.idFile != 0
          ) {
            apiGetConFile(imageResponse.data.idFile, function (fileResponse) {
              if (
                fileResponse != null &&
                fileResponse.status >= 200 &&
                fileResponse.status < 400
              ) {
                setCurrentNodeLoadingImageFile(fileResponse.data);
              }
              setCurrentNodeLoadingImage(imageResponse.data);
            });
          } else {
            setCurrentNodeLoadingImage(imageResponse.data);
            setCurrentNodeLoadingImageFile(null);
          }
        } else {
          console.log("currentAvatar", null);
          setCurrentNodeLoadingImage(null);
          setCurrentNodeLoadingImageFile(null);
        }
      }
    );
  }

  function handleOnsave() {
    //55
    if (
      updatedNode.tipoAvvio == 4 &&
      (updatedNode.apiEsterna == null || updatedNode.apiEsterna.length <= 5)
    ) {
      return;
    }
    apiPostAvpNodoAdd(
      {
        ...updatedNode,
        sysUser: "",
        sysDate: new Date().toISOString(),
        sysAttivo: true,
      },
      function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          if (currentNodeAvatar != null) {
            const avatar = {
              idNodo: selectedNode.idNodo,
              idLingua: currentNodeAvatar.idLingua,
              idFile: currentNodeAvatar.idFile,
              tipoAvatar: currentNodeAvatar.tipoAvatar,
              formato: "",
              speechText: "",
            };
            apiPostAvpNodoAvatar(avatar, function (avatarResponse) {
              if (
                avatarResponse != null &&
                avatarResponse.status >= 200 &&
                avatarResponse.status < 400
              ) {
                setAlertMessage("success");
                aggiornaAvp(avp.idAvp);
              } else {
                setAlertMessage("error");
              }
            });
          } else {
            setAlertMessage("success");
            aggiornaAvp(avp.idAvp);
          }
        }
      }
    );
  }

  function handleOnRefresh() {
    setUpdatedNode(selectedNode);
  }

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "85vh",
        width: 500,
        backgroundColor: "white",
        zIndex: 100,
        overflow: "auto",
        fontSize: 13,
        paddingTop: 10,
        paddingLeft: 10,
        paddingRight: 10,
      }}
    >
      <div>
        <h1 style={{ fontSize: 28, fontWeight: "bold" }}>
          {selectedNode.descNodo}
          <span
            style={{ fontSize: 15, fontWeight: "normal" }}
          >{`(ID:${selectedNode.idNodo})`}</span>
        </h1>
        <div style={{ position: "relative", float: "right" }}>
          <button
            style={{ height: "35px" }}
            onClick={() => {
              setSelectedNode(undefined);
            }}
          >
            {selectedLinguaTesto?.AvpGraphNodeCloseWindows}
          </button>
        </div>
      </div>

      <div id="avp-gestioneavp-node-section">
        <div className="avp-cms-tab clearfix">
          <div className="avp-cms-tab-item avp-cms-tab-item-selected">
            {selectedLinguaTesto?.AvpGraphNodeTabProperty}
          </div>
        </div>
        <div className="avp-cms-tab-content clearfix">
          <div id="avp-gestioneavp-node-properties-section">
            <div className="avp-cms-screen-content-row clearfix">
              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-descr" className="required">
                  {selectedLinguaTesto?.AvpGraphNodeFormName}
                </label>
                <br />
                <input
                  id="avp-form-descr"
                  type="text"
                  value={updatedNode != null ? updatedNode.descNodo : ""}
                  onChange={(event) => onChangeValue(event, "descNodo")}
                />
              </div>
              <div
                className="avp-cms-screen-content-column"
                style={{ width: 200 }}
              >
                <label htmlFor="avp-form-codeasset" className="required">
                  {selectedLinguaTesto?.AvpGraphNodeFormStartType}
                </label>
                <br />
                <select
                  value={updatedNode != null ? updatedNode.tipoAvvio : ""}
                  onChange={(event) => onChangeValue(event, "tipoAvvio")}
                >
                  {tipiAvvio != null ? (
                    tipiAvvio.map((tipo, i) => {
                      return (
                        <option key={tipo.idTipoAvvio} value={tipo.idTipoAvvio}>
                          {tipo.descTipoAvvio}
                        </option>
                      );
                    })
                  ) : (
                    <option></option>
                  )}
                </select>
              </div>
            </div>
            <div
              className="avp-cms-screen-content-row clearfix"
              style={{
                display: updatedNode.tipoAvvio == 3 ? "block" : "none",
              }}
            >
              <div>{selectedLinguaTesto?.AvpGraphNodeFormAvatar}</div>
              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-pip-avatar-posx">
                  {selectedLinguaTesto?.AvpGraphNodeFormAvatarPosX}
                </label>
                <br />
                <input
                  id="avp-form-pip-avatar-posx"
                  type="number"
                  min="0"
                  max="100"
                  value={
                    updatedNode != null &&
                    updatedNode.pipAvatarX != null &&
                    updatedNode.pipAvatarX != "undefined"
                      ? updatedNode.pipAvatarX
                      : "0"
                  }
                  onChange={(event) => onChangeValueNumber(event, "pipAvatarX")}
                />
              </div>
              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-pip-avatar-posy">
                  {selectedLinguaTesto?.AvpGraphNodeFormAvatarPosY}
                </label>
                <br />
                <input
                  id="avp-form-pip-avatar-posy"
                  type="number"
                  min="0"
                  max="100"
                  value={
                    updatedNode != null &&
                    updatedNode.pipAvatarY != null &&
                    updatedNode.pipAvatarY != "undefined"
                      ? updatedNode.pipAvatarY
                      : "0"
                  }
                  onChange={(event) => onChangeValueNumber(event, "pipAvatarY")}
                />
              </div>
              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-pip-avatar-dimw">
                  {selectedLinguaTesto?.AvpGraphNodeFormAvatarDimW}
                </label>
                <br />
                <input
                  id="avp-form-pip-avatar-dimw"
                  type="number"
                  min="0"
                  max="100"
                  value={
                    updatedNode != null &&
                    updatedNode.pipAvatarW != null &&
                    updatedNode.pipAvatarW != "undefined"
                      ? updatedNode.pipAvatarW
                      : "100"
                  }
                  onChange={(event) => onChangeValueNumber(event, "pipAvatarW")}
                />
              </div>
              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-pip-avatar-dimh">
                  {selectedLinguaTesto?.AvpGraphNodeFormAvatarDimH}
                </label>
                <br />
                <input
                  id="avp-form-pip-avatar-dimh"
                  type="number"
                  min="0"
                  max="100"
                  value={
                    updatedNode != null &&
                    updatedNode.pipAvatarH != null &&
                    updatedNode.pipAvatarH != "undefined"
                      ? updatedNode.pipAvatarH
                      : "100"
                  }
                  onChange={(event) => onChangeValueNumber(event, "pipAvatarH")}
                />
              </div>
              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-pip-avatar-z">
                  {selectedLinguaTesto?.AvpGraphNodeFormAvatarZIndex}
                </label>
                <br />
                <input
                  id="avp-form-pip-avatar-z"
                  type="number"
                  min="0"
                  max="250"
                  value={
                    updatedNode != null &&
                    updatedNode.pipAvatarZ != null &&
                    updatedNode.pipAvatarZ != "undefined"
                      ? updatedNode.pipAvatarZ
                      : "0"
                  }
                  onChange={(event) => onChangeValueNumber(event, "pipAvatarZ")}
                />
              </div>
            </div>
            <div
              className="avp-cms-screen-content-row clearfix"
              style={{
                display: updatedNode.tipoAvvio == 3 ? "block" : "none",
              }}
            >
              <div>{selectedLinguaTesto?.AvpGraphNodeFormContenuti}</div>
              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-pip-playlist-posx">
                  {selectedLinguaTesto?.AvpGraphNodeFormContenutiPosX}
                </label>
                <br />
                <input
                  id="avp-form-pip-playlist-posx"
                  type="number"
                  min="0"
                  max="100"
                  value={
                    updatedNode != null &&
                    updatedNode.pipContentsX != null &&
                    updatedNode.pipContentsX != "undefined"
                      ? updatedNode.pipContentsX
                      : "0"
                  }
                  onChange={(event) =>
                    onChangeValueNumber(event, "pipContentsX")
                  }
                />
              </div>
              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-pip-playlist-posy">
                  {selectedLinguaTesto?.AvpGraphNodeFormContenutiPosY}
                </label>
                <br />
                <input
                  id="avp-form-pip-playlist-posy"
                  type="number"
                  min="0"
                  max="100"
                  value={
                    updatedNode != null &&
                    updatedNode.pipContentsY != null &&
                    updatedNode.pipContentsY != "undefined"
                      ? updatedNode.pipContentsY
                      : "0"
                  }
                  onChange={(event) =>
                    onChangeValueNumber(event, "pipContentsY")
                  }
                />
              </div>
              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-pip-playlist-dimw">
                  {selectedLinguaTesto?.AvpGraphNodeFormContenutiDimW}
                </label>
                <br />
                <input
                  id="avp-form-pip-playlist-dimw"
                  type="number"
                  min="0"
                  max="100"
                  value={
                    updatedNode != null &&
                    updatedNode.pipContentsW != null &&
                    updatedNode.pipContentsW != "undefined"
                      ? updatedNode.pipContentsW
                      : "100"
                  }
                  onChange={(event) =>
                    onChangeValueNumber(event, "pipContentsW")
                  }
                />
              </div>
              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-pip-playlist-dimh">
                  {selectedLinguaTesto?.AvpGraphNodeFormContenutiDimH}
                </label>
                <br />
                <input
                  id="avp-form-pip-playlist-dimh"
                  type="number"
                  min="0"
                  max="100"
                  value={
                    updatedNode != null &&
                    updatedNode.pipContentsH != null &&
                    updatedNode.pipContentsH != "undefined"
                      ? updatedNode.pipContentsH
                      : "100"
                  }
                  onChange={(event) =>
                    onChangeValueNumber(event, "pipContentsH")
                  }
                />
              </div>
              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-pip-playlist-z">
                  {selectedLinguaTesto?.AvpGraphNodeFormContenutiZindex}
                </label>
                <br />
                <input
                  id="avp-form-pip-playlist-z"
                  type="number"
                  min="0"
                  max="250"
                  value={
                    updatedNode != null &&
                    updatedNode.pipContentsZ != null &&
                    updatedNode.pipContentsZ != "undefined"
                      ? updatedNode.pipContentsZ
                      : "0"
                  }
                  onChange={(event) =>
                    onChangeValueNumber(event, "pipContentsZ")
                  }
                />
              </div>
            </div>
            <div className="avp-cms-screen-content-row clearfix">
              <label htmlFor="avp-form-apiesterna" className="required">
                {selectedLinguaTesto?.AvpGraphNodeFormExsternalApi}
              </label>
              <br />
              {/* {updatedNode.tipoAvvio} */}
              {errorApiEsterna && (
                <p style={{ color: "#FFD54F" }}>Inserire Api Esterna</p>
              )}
              <textarea
                id="avp-form-apiesterna"
                type="text"
                style={{
                  maxWidth: "none",
                  borderColor: errorApiEsterna ? "#FFD54F" : "",
                }}
                rows="4"
                value={
                  updatedNode != null && updatedNode.apiEsterna != null
                    ? updatedNode.apiEsterna
                    : ""
                }
                onChange={(event) => onChangeValue(event, "apiEsterna")}
              ></textarea>
            </div>
            <div className="avp-cms-screen-content-row clearfix">
              <input
                id="avp-form-flagGoBack"
                type="checkbox"
                onChange={(event) => onChangeValueCheckbox(event, "flagGoBack")}
                checked={
                  updatedNode != null && updatedNode.flagGoBack ? "checked" : ""
                }
              />
              <label htmlFor="avp-form-flagGoBack">
                {selectedLinguaTesto?.AvpGraphNodeFormFlagGoBack}
              </label>
            </div>
            {/* <input
              id="avp-form-SkipNextNode"
              type="checkbox"
              onChange={onChangeSetSelectedSkipToNode}
              checked={
                selectedSkipToNode != null && selectedSkipToNode
                  ? "checked"
                  : ""
              }
            />

            <label style={{ marginRight: 20 }} htmlFor="avp-form-SkipNextNode">
              {selectedLinguaTesto?.AvpGraphNodeFormSkipToNextNode}
            </label>
            {selectedSkipToNode && (
              <select
                value={updatedNode.skipToNextNode}
                onChange={(event) => onChangeValue(event, "skipToNextNode")}
              >
                <option value={null}></option>
                {currentNodeArchi &&
                  currentNodeArchi.map((arco) => (
                    <option value={arco.idArco}>{arco.testo}</option>
                  ))}
              </select>
            )} */}
            <div className="avp-cms-tab clearfix">
              {lingue != null && lingue.length > 0 ? (
                lingue.map((item, i) => {
                  let isSelected =
                    currentLingua != null &&
                    currentLingua.idLingua == item.idLingua
                      ? true
                      : false;
                  let selectedClass = isSelected
                    ? "avp-cms-tab-item-selected"
                    : "";
                  return (
                    <div
                      key={item.idLingua}
                      className={"avp-cms-tab-item " + selectedClass}
                      onClick={() => handleChnageLanguage(item.idLingua)}
                    >
                      {item.descrizione}
                    </div>
                  );
                })
              ) : (
                <br />
              )}
            </div>
            <div className="avp-cms-screen-content-row clearfix">
              <AvpNodeContentArcsSection
                pAvp={avp}
                pNode={selectedNode}
                pArchi={currentNodeArchi}
                pLingua={currentLingua}
                pActionCallback={nodeActionCallback}
              />
            </div>
            {/*Agent*/}
            <div
              className="avp-cms-screen-content-row clearfix"
              style={{ marginTop: "30px" }}
            >
              <div className="group">
                <div
                  className="avp-gestioneavp-nodearcs-section-title"
                  style={{ position: "relative", float: "left" }}
                >
                  {selectedLinguaTesto?.AvpGraphNodeFormAgent}
                </div>
              </div>
              <div
                className="avp-cms-screen-content-column"
                style={{ marginRight: "0" }}
              >
                <label htmlFor="avp-form-avatar">
                  {selectedLinguaTesto?.AvpGraphNodeFormAgent}
                </label>
                <br />
                <input
                  id="avp-form-filetoanimate"
                  style={{
                    maxWidth: "none",
                    width: 140,
                    position: "relative",
                    float: "left",
                  }}
                  type="text"
                  disabled={true}
                  value={
                    currentNodeAgent != null ? currentNodeAgent.descFile : ""
                  }
                />
                <button
                  onClick={handleSelectAgent}
                  style={{
                    height: "34px",
                    marginLeft: 20,
                    width: 80,
                    position: "relative",
                    float: "right",
                  }}
                >
                  {selectedLinguaTesto?.AvpGraphNodeFormButtonSelect}
                </button>
              </div>
              <div
                className="avp-cms-screen-content-column"
                style={{
                  height: "34px",
                  marginLeft: 10,
                  marginTop: 20,
                  position: "relative",
                  float: "left",
                }}
              >
                <img
                  data-action="delete"
                  src="/images/delete_btn.svg"
                  onClick={onDeleteAgent}
                  title={selectedLinguaTesto?.AvpGraphNodeFormDeleteButton}
                />
              </div>
            </div>
            {/* Avatar */}
            <div
              className="avp-cms-screen-content-row clearfix"
              style={{ marginTop: "30px" }}
            >
              <div className="group">
                <div
                  className="avp-gestioneavp-nodearcs-section-title"
                  style={{ position: "relative", float: "left" }}
                >
                  {selectedLinguaTesto?.AvpGraphNodeFormAvatar}
                </div>
              </div>
              {/* <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-tipoavatar" className="required">
                  Tipo avatar
                </label>
                <br />
                <select
                  id="avp-form-tipoavatar"
                  style={{ width: 180 }}
                  value={
                    currentNodeAvatar != null
                      ? currentNodeAvatar.tipoAvatar
                      : ""
                  }
                  onChange={onTipoAvatarChange}
                >
                  <option key={-1} value="">
                    Selezionare...
                  </option>
                  {tipoAvatarList != null && tipoAvatarList.length > 0 ? (
                    tipoAvatarList.map((item, i) => {
                      return (
                        <option
                          key={item.idTipoAvatar}
                          value={item.idTipoAvatar}
                        >
                          {item.descTipoAvatar}
                        </option>
                      );
                    })
                  ) : (
                    <option></option>
                  )}
                </select>
              </div>*/}
              <div
                className="avp-cms-screen-content-column"
                style={{ marginRight: "0" }}
              >
                <label htmlFor="avp-form-avatar" className="required">
                  {selectedLinguaTesto?.AvpGraphNodeFormAvatar}
                </label>
                <br />
                <input
                  id="avp-form-filetoanimate"
                  style={{
                    maxWidth: "none",
                    width: 140,
                    position: "relative",
                    float: "left",
                  }}
                  type="text"
                  disabled={true}
                  value={
                    currentNodeAvatarFile != null
                      ? currentNodeAvatarFile.descFile
                      : ""
                  }
                />
                <button
                  onClick={handleSelectAvatar}
                  // onClick={handleSelectFile}
                  style={{
                    height: "34px",
                    marginLeft: 20,
                    width: 80,
                    position: "relative",
                    float: "right",
                  }}
                >
                  {selectedLinguaTesto?.AvpGraphNodeFormButtonSelect}
                </button>
              </div>
            </div>
            {/* loading file */}
            {currentNodeAvatar != null && currentNodeAvatar.idFile && (
              <div
                className="avp-cms-screen-content-row clearfix"
                style={{ marginTop: "30px" }}
              >
                <div className="group">
                  <div
                    className="avp-gestioneavp-nodearcs-section-title"
                    style={{ position: "relative", float: "left" }}
                  >
                    {selectedLinguaTesto?.AvpGraphNodeFormLoadingFileAvatar}
                  </div>
                </div>
                <div
                  className="avp-cms-screen-content-column"
                  style={{ marginRight: "0" }}
                >
                  <label htmlFor="avp-form-avatar">
                    {selectedLinguaTesto?.AvpGraphNodeFormLoadingFileAvatar}
                  </label>
                  <br />
                  <input
                    id="avp-form-filetoanimate"
                    style={{
                      maxWidth: "none",
                      width: 140,
                      position: "relative",
                      float: "left",
                    }}
                    type="text"
                    disabled={true}
                    value={
                      currentNodeLoadingFile != null
                        ? currentNodeLoadingFile.descFile
                        : ""
                    }
                  />
                  <button
                    onClick={handleOnSelectLoadingFile}
                    style={{
                      height: "34px",
                      marginLeft: 20,
                      width: 80,
                      position: "relative",
                      float: "right",
                    }}
                  >
                    {selectedLinguaTesto?.AvpGraphNodeFormButtonSelect}
                  </button>
                </div>
                <div
                  className="avp-cms-screen-content-column"
                  style={{
                    height: "34px",
                    marginLeft: 10,
                    marginTop: 20,
                    position: "relative",
                    float: "left",
                  }}
                >
                  <img
                    data-action="delete"
                    src="/images/delete_btn.svg"
                    onClick={handleDeleteLoadingImage}
                    title={selectedLinguaTesto?.AvpGraphNodeFormDeleteButton}
                  />
                </div>
              </div>
            )}
            <div
              className="avp-cms-screen-content-row clearfix"
              style={{ marginTop: "30px" }}
            >
              <AvpNodeContentPlaylistSection
                pAvp={avp}
                pNode={selectedNode}
                pLingua={currentLingua}
                pActionCallback={nodeActionCallback}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          position: "sticky",
          bottom: 0,
          paddingTop: 20,
          height: 70,
          backgroundColor: "white",
        }}
      >
        <div id="avp-footer-save-container-right">
          <div id="avp-footer-save-submit">
            <button onClick={handleOnsave}>
              {selectedLinguaTesto?.AvpGraphNodeFormSaveButton}
            </button>
          </div>
          <div id="avp-footer-save-cancel">
            <button onClick={handleOnRefresh}>
              {selectedLinguaTesto?.AvpGraphNodeFormResetButton}
            </button>
            {/* <button onClick={()=>handleCancel()} >ANNULLA</button> */}
          </div>
        </div>
      </div>
    </div>
  );
}
